import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=fc8ac9be&scoped=true"
import script from "./Key.vue?vue&type=script&lang=js"
export * from "./Key.vue?vue&type=script&lang=js"
import style0 from "./Key.vue?vue&type=style&index=0&id=fc8ac9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8ac9be",
  null
  
)

export default component.exports